import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

export const createUCCQueueNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'queue',
  text: translateFn('mnu_ucc_queue'),
  identity: '/secure/ucc/queue',
  permission: 'UCC_VIEW',
}))

export default Loadable(() => import('./UCCQueue'))
